import createVueApp from '@phoenix/createVueApp';
import GepForm from '@maison/components/form/GepForm.vue';

const app = createVueApp({}, true);
app.component('GepForm', GepForm);
app.mount('#phoenix-gep-form');
